<template>
  <div class="card-wrapper">
    {{yield}}
  </div>
</template>
